import { makeAutoObservable } from "mobx";
import { updateUserSettings } from "../components/user-settings/web";
import { ViewType } from "../modules/clients-overview/store/store";

export const SortFieldValue = "_id";
export const SortFieldDesc = "_desc";

export interface SortOption {
    id: string;
    desc: boolean;
}

export enum UserSettings {
    RESIDENT_VIEW_TYPE = "resident_view_type",
    PRIVACY_MODE = "privacy_mode",
    ZOOM_LEVEL = "zoom_level",
    CHART_TYPE = "chart_type",
}

export enum SortSettings {
    RESIDENT_STATUS = "resident_status_sort",
    ALARM_OVERVIEW = "alarm_overview_sort",
    MANAGE_RESIDENTS = "manage_residents_sort",
    INACTIVE_RESIDENTS = "inactive_residents_sort",
    MANAGE_SENSORS = "manage_sensors_sort",
    MANAGE_CAMERAS = "manage_cameras_sort",
    MANAGE_MARI = "manage_mari_sort",
    MANAGE_PERIPHERALS = "manage_peripherals_sort",
    MANAGE_STATUS = "manage_status_sort",
    MANAGE_ALERTS = "manage_alers_sort",
}

export const DefaultUserSettings: Record<string, any> = {
    [UserSettings.RESIDENT_VIEW_TYPE]: ViewType.LIST,
    [UserSettings.PRIVACY_MODE]: false,
    [UserSettings.ZOOM_LEVEL]: "1",
    [UserSettings.CHART_TYPE]: "daily",
    [SortSettings.RESIDENT_STATUS]: { id: "status", desc: true },
    [SortSettings.ALARM_OVERVIEW]: { id: "clientName", desc: false },
    [SortSettings.MANAGE_RESIDENTS]: { id: "clientName", desc: false },
    [SortSettings.INACTIVE_RESIDENTS]: { id: "clientName", desc: false },
    [SortSettings.MANAGE_SENSORS]: { id: "status", desc: true },
    [SortSettings.MANAGE_CAMERAS]: { id: "distance", desc: false },
    [SortSettings.MANAGE_MARI]: { id: "mariName", desc: false },
    [SortSettings.MANAGE_PERIPHERALS]: { id: "mariName", desc: false },
    [SortSettings.MANAGE_STATUS]: { id: "statusName", desc: false },
    [SortSettings.MANAGE_ALERTS]: { id: "alertName", desc: false },
};

export default class UserSettingsStore {
    public userSettings: Record<string, any> = {};

    constructor() {
        makeAutoObservable(this);
    }

    public getUserSetting(key: string) {
        if (this.userSettings[key] === undefined) {
            return DefaultUserSettings[key];
        }
        return this.userSettings[key];
    }

    public initializeSetting(key: string, setting: any) {
        let settingValue = setting;

        if (settingValue === undefined) {
            settingValue = DefaultUserSettings[key].id;
        }

        this.userSettings[key] = settingValue;
    }

    public initializeSortSetting(
        key: string,
        id: string | undefined,
        desc: string | undefined
    ) {
        let idValue = id;
        let descValue = desc;

        if (idValue === undefined) {
            idValue = DefaultUserSettings[key].id;
        }

        if (descValue === undefined) {
            descValue = DefaultUserSettings[key].desc.toString();
        }

        this.userSettings[key] = { id: idValue, desc: descValue === "true" };
    }

    public setUserSetting(key: string, value: any) {
        this.userSettings[key] = value;
        updateUserSettings(key, value);
    }

    public setSortSetting(key: string, value: SortOption) {
        this.userSettings[key] = value;
        updateUserSettings(key + SortFieldValue, value.id);
        updateUserSettings(key + SortFieldDesc, value.desc);
    }
}
